if (!window.Eurus.loadedScript.has('msc-personalization.js')) {
  window.Eurus.loadedScript.add('msc-personalization.js');

  window.mscPersonalization = function(sectionId) {
    const configEl = document.getElementById('msc-personalization-config-' + sectionId);
    const config = configEl ? JSON.parse(configEl.textContent) : {};
    const productFormId = config.productFormId || '';

    // Add-on variant map: lineCount → { id, price }
    const addonVariants = config.addonVariants || {};

    // Generate a unique ID to link the main product and its add-on in the cart.
    // Uses crypto.randomUUID where available, falls back to timestamp + random.
    function _generatePersonalizationId() {
      if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return crypto.randomUUID();
      }
      return Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 9);
    }

    // Get the current add-on surcharge price (in cents) for a given line count
    function _getAddonPrice(lineCount) {
      const variant = addonVariants[String(lineCount)];
      return variant ? variant.price : 0;
    }

    // Find all price <span> elements on the PDP that should reflect the surcharge:
    // 1. The main price block below the title: #price-{sectionId} .price > span
    // 2. The ATC button inline price: .x-atc-text .price > span
    function _getPriceSpans() {
      const spans = [];
      const priceBlock = document.getElementById('price-' + sectionId);
      if (priceBlock) {
        // Sale price takes priority if present, otherwise regular price
        const sale = priceBlock.querySelector('.price-sale');
        const regular = priceBlock.querySelector('.price:not(.price-compare) > span');
        if (sale) spans.push(sale);
        else if (regular) spans.push(regular);
      }
      // ATC button price (may appear in multiple forms: main, sticky, installment)
      const section = document.getElementById('shopify-section-' + sectionId);
      if (section) {
        section.querySelectorAll('.x-atc-text .price:not(.price-compare) > span, .x-atc-text .price-sale').forEach(el => {
          spans.push(el);
        });
      }
      return spans;
    }

    // Parse cents from a price string like "$45.00" or "45,00 €"
    function _parseCents(text) {
      const cleaned = text.replace(/[^0-9.,]/g, '').replace(',', '.');
      return Math.round(parseFloat(cleaned) * 100) || 0;
    }

    // Format cents back into a price string, preserving the original currency symbol/position
    function _formatPrice(cents, referenceText) {
      const formatted = (cents / 100).toFixed(2);
      // Detect currency symbol and whether it's prefix or suffix
      const trimmed = referenceText.trim();
      const numMatch = trimmed.match(/[\d.,]+/);
      if (!numMatch) return '$' + formatted;
      const numStart = numMatch.index;
      const numEnd = numStart + numMatch[0].length;
      const prefix = trimmed.slice(0, numStart);
      const suffix = trimmed.slice(numEnd);
      return prefix + formatted + suffix;
    }

    // Update the displayed price on the PDP to show base + surcharge
    function _updatePriceDisplay(addonPriceCents) {
      _getPriceSpans().forEach(el => {
        // Store the original base price on first call so we can recalculate
        if (!el.dataset.mscBasePrice) {
          el.dataset.mscBasePrice = _parseCents(el.textContent);
          el.dataset.mscOrigText = el.textContent.trim();
        }
        const baseCents = parseInt(el.dataset.mscBasePrice) || 0;
        const totalCents = baseCents + addonPriceCents;
        el.textContent = _formatPrice(totalCents, el.dataset.mscOrigText);
      });
    }

    // Reset price display back to the base price
    function _resetPriceDisplay() {
      _getPriceSpans().forEach(el => {
        if (el.dataset.mscOrigText) {
          el.textContent = el.dataset.mscOrigText;
          delete el.dataset.mscBasePrice;
          delete el.dataset.mscOrigText;
        }
      });
    }

    // After Eurus updates the variant (user changed Color/Size), it fires this event.
    // Eurus replaces the price/button DOM, so cached base prices are gone.
    // We need to re-apply the surcharge to the new base price.
    document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, () => {
      setTimeout(() => {
        // Clear cached base prices — the DOM was replaced by Eurus
        _getPriceSpans().forEach(el => {
          delete el.dataset.mscBasePrice;
          delete el.dataset.mscOrigText;
        });
        // Re-apply surcharge if personalization is active
        const component = document.querySelector(`#shopify-section-${sectionId} .msc-personalization`);
        if (component && component.__x && component.__x.$data.wantPersonalization) {
          const lineCount = component.__x.$data.lineCount;
          _updatePriceDisplay(_getAddonPrice(lineCount));
        }
      }, 100);
    });

    return {
      wantPersonalization: false,
      lineCount: 1,
      lines: ['', '', ''],
      hasTextError: false,
      selectedFontIndex: 0,
      selectedFontFamily: '',
      selectedFontName: '',
      selectedThreadIndex: 0,
      selectedThreadName: '',
      selectedThreadColor: '',
      productFormId: productFormId,
      personalizationId: '',
      addonVariantId: '',

      init() {
        // Generate a unique personalization ID for linking cart items
        this.personalizationId = _generatePersonalizationId();
        // Set default add-on variant ID (One Line)
        this.addonVariantId = addonVariants['1'] ? String(addonVariants['1'].id) : '';

        // Seed defaults from the first font/thread options (if configured in metafields)
        if (config.defaultFontFamily) this.selectedFontFamily = config.defaultFontFamily;
        if (config.defaultFontName) this.selectedFontName = config.defaultFontName;
        if (config.defaultThreadName) this.selectedThreadName = config.defaultThreadName;
        if (config.defaultThreadColor) this.selectedThreadColor = config.defaultThreadColor;

        // Watch for Eurus adding 'required-picker' to our inputs (validation failed)
        // and dispatch an event so the snugglegram banner can react.
        const observer = new MutationObserver(() => {
          const hasError = !!document.querySelector(
            `#shopify-section-${sectionId} .msc-text-input.required-picker`
          );
          document.dispatchEvent(new CustomEvent('msc:personalization:text-error', { detail: { hasError } }));
        });
        const section = document.getElementById('shopify-section-' + sectionId);
        if (section) {
          observer.observe(section, { subtree: true, attributeFilter: ['class'] });
        }
      },

      setPersonalization(value) {
        this.wantPersonalization = value;
        if (!value) {
          _resetPriceDisplay();
          this.clearPreview();
        } else {
          this.applyLineCountPrice();
        }
      },

      setLineCount(count) {
        this.lineCount = count;
        this.applyLineCountPrice();
        this.updatePreview();
      },

      applyLineCountPrice() {
        // Update which add-on variant will be added to cart
        const variant = addonVariants[String(this.lineCount)];
        this.addonVariantId = variant ? String(variant.id) : '';
        // Update the displayed price to include the surcharge
        _updatePriceDisplay(_getAddonPrice(this.lineCount));
      },

      setFont(index, fontFamily, fontName) {
        this.selectedFontIndex = index;
        this.selectedFontFamily = fontFamily;
        this.selectedFontName = fontName;
        this.updatePreview();
      },

      setThread(index, colorName, colorValue) {
        this.selectedThreadIndex = index;
        this.selectedThreadName = colorName;
        this.selectedThreadColor = colorValue || '';
        this.updatePreview();
      },

      updatePreview() {
        document.dispatchEvent(new CustomEvent('msc:preview:update', {
          detail: {
            lines: this.lines.slice(0, this.lineCount),
            fontFamily: this.selectedFontFamily,
            threadColor: this.selectedThreadColor || ''
          }
        }));
      },

      clearPreview() {
        document.dispatchEvent(new CustomEvent('msc:preview:update', {
          detail: { lines: [], fontFamily: '', threadColor: '' }
        }));
      }
    };
  };

  window.mscPreviewOverlay = function() {
    return {
      lines: [],
      fontFamily: '',
      threadColor: '',
      init() {
        document.addEventListener('msc:preview:update', (e) => {
          this.lines = (e.detail.lines || []).filter(l => l && l.trim().length > 0);
          this.fontFamily = e.detail.fontFamily || '';
          this.threadColor = e.detail.threadColor || '';
        });
      }
    };
  };

  // Cart quantity sync: after any cart change, check if personalization add-on
  // quantities are out of sync with their parent products and fix them.
  document.addEventListener('eurus:cart:items-changed', () => {
    fetch(Shopify.routes.root + 'cart.js', { credentials: 'same-origin' })
      .then(r => r.json())
      .then(cart => {
        // Build a map of _personalization_id → main product quantity
        const mainQtyById = {};
        const addonItemsByPId = {};

        cart.items.forEach(item => {
          const pId = item.properties && item.properties['_personalization_id'];
          if (!pId) return;

          if (item.handle === 'personalization-add-on') {
            addonItemsByPId[pId] = item;
          } else {
            mainQtyById[pId] = item.quantity;
          }
        });

        // Check for mismatches and build an update payload
        const updates = {};
        let needsUpdate = false;

        Object.entries(addonItemsByPId).forEach(([pId, addonItem]) => {
          const expectedQty = mainQtyById[pId];
          if (expectedQty === undefined) {
            // Main product was removed but add-on still exists — remove it
            updates[addonItem.key] = 0;
            needsUpdate = true;
          } else if (addonItem.quantity !== expectedQty) {
            updates[addonItem.key] = expectedQty;
            needsUpdate = true;
          }
        });

        if (!needsUpdate) return;

        fetch(Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
      })
      .catch(() => {});
  });
}
